import { render } from "./PendingApprovalHygiene.vue?vue&type=template&id=8e073b9c&scoped=true"
import script from "./PendingApprovalHygiene.vue?vue&type=script&lang=js"
export * from "./PendingApprovalHygiene.vue?vue&type=script&lang=js"

import "./PendingApprovalHygiene.vue?vue&type=style&index=0&id=8e073b9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e073b9c"]])

export default __exports__